export const projects = [
{
id: 5,
title: 'Autonomous Golf Cart',
tag: 'MS Thesis',
image: `${process.env.PUBLIC_URL}/golfcart_card.jpg`,
description: 'Drive-by-wire retrofit of a Yamaha G22E into a low-cost ROS 2 research platform for sim-to-real autonomy.',
site: 'https://jacobigo.github.io/autonomous-golf-cart/'
},
{
id: 1,
title: 'Perception with Waymo Dataset',
image: `${process.env.PUBLIC_URL}/single_frame.png`,
description: 'LiDAR-camera fusion pipeline for 3D semantic segmentation on the Waymo Open Dataset.',
github: 'https://github.com/jacobigo/waymo_perception'
},
{
id: 2,
title: 'Card Counting CV',
image: `${process.env.PUBLIC_URL}/card_image.png`,
description: 'Computer vision pipeline that detects and counts playing cards using a YOLO-based detector and OpenCV overlay.',
github: 'https://github.com/jacobigo/card-counting-ml'
},
{
id: 3,
title: 'Instructional Agent Video Generation',
image: `${process.env.PUBLIC_URL}/instruct_image.png`,
description: 'Utilizes Instructional Agents\' output to generate online course lectures.',
github: 'https://github.com/jacobigo/instruct_video_research'
},
{
id: 4,
title: 'College Football Ranking System',
image: `${process.env.PUBLIC_URL}/Auburn_vs_Georgia.png`,
description: 'Uses advanced ELO & regularization to determine rankings for teams, can visualize & compare teams\' game history',
github: 'https://github.com/jacobigo/cfb'
}
];

export const internships = [
{
id: 1,
role: 'Software Engineering Intern',
company: 'FOX Sports',
period: 'Spring 2026, Summer 2026, Fall 2026',
description: 'Developed ML stream identification system and dashboard using OpenCLIP and P-Hash, hosted on an NVIDIA DGX Spark with Docker.\n\n Achieved 89% F1 score with 8x potential scalability.',
link: 'https://www.linkedin.com/in/jacob-igo/'
},
{
id: 2,
role: 'Machine Learning Researcher',
company: 'Paragon Autonomous',
period: 'Fall 2024 - Fall 2025',
description: 'Worked for student-led startup on autonomous firefighting drones. Focused on LiDAR and image fusion to perform semantic segmentation. Used PyTorch, GCP VM, OpenCV, ROS2',
link: 'https://www.linkedin.com/in/jacob-igo/'
},
{
id: 3,
role: 'Research and Development Intern',
company: 'Infosys',
period: 'Summer 2025',
description: 'Created various POCs for external clients, flew out to Indianapolis for product pitch and live demo. Gained profiency with Huggingface, RAG, Neo4j, and more.',
link: 'https://www.linkedin.com/in/jacob-igo/'
}
];

export const skills = [
'Python',
'C++',
'React',
'OpenCV',
'PyTorch',
'ROS2',
'SQL',
'Docker',
'Scikit-Learn',
'Matplotlib',
'Numpy',
'Pandas',
'Huggingface',
'GCP',
'AWS'
];